<script>
  import { env as envPublic } from '$env/dynamic/public';
  import { Footer, FooterBrand, FooterLinkGroup, FooterLink } from 'flowbite-svelte';

  /** @type {string} */
  export let logoUrl = '';

  /** @type {string} */
  export let logoUrlSecond = '';

  /** @type {string} */
  export let contact = '';

  /** @type {string} */
  export let copyright = '';

  /**
   * @type {object} items
   * @property {string} title
   * @property {object} link
   */
  export let items;

  /**
   * @type {Array<{link_text: string, link: string, image_url?: string, highlight?: string}>}
   */
  export let links = [];
</script>

<Footer class="main">
  <div class="footer-nav">
    <div class="footer-brand footer-nav-item">
      <FooterBrand href="/" src={logoUrl} alt={envPublic.PUBLIC_APP_NAME} name={envPublic.PUBLIC_APP_NAME} />
      <div class="footer-contact">
        {contact}
      </div>
      {#if logoUrlSecond}
        <FooterBrand href="/" src={logoUrlSecond} alt={envPublic.PUBLIC_APP_NAME} name={envPublic.PUBLIC_APP_NAME} />
      {/if}
      {#if links.length}
        <div class="links">
          {#each links as link}
            {#if !link.image_url}
              <a href={link.link} class={link?.highlight ? 'highlight' : 'base'}>
                {link.link_text}
              </a>
            {:else}
              <a href={link.link} class="link">
                <img src={link.image_url} alt="" />
              </a>
            {/if}
          {/each}
        </div>
      {/if}
    </div>
    {#each items as item}
      <div class="footer-group footer-nav-item">
        <h2>{item.title}</h2>
        {#each item.links as link}
          <FooterLinkGroup>
            <FooterLink href={link.href} target={link.target} rel={item.rel}>{link.label}</FooterLink>
          </FooterLinkGroup>
        {/each}
      </div>
    {/each}
    {#if copyright}
      <div class="copyright">
        {copyright}
      </div>
    {/if}
  </div>
</Footer>
